import type { Action } from "../../actions/types";

export type StoreState = boolean;

export const initialState = false;

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  switch (action.type) {
    case "GET_CUSTOMER_LEDGER_ACTIVITY_SUCCESS":
    case "GET_CUSTOMER_LEDGER_ACTIVITY_FAILURE":
      return false;

    case "GET_CUSTOMER_LEDGER_ACTIVITY_REQUEST":
      return true;

    default:
      return state;
  }
}
